import {useClient} from '@adamlip/okeoke.client';
import {Image} from '@heroui/react';

export default function VivaSmart({agent}) {
	const {getName} = useClient();

	return (
		<div className='flex flex-row items-center gap-2 w-full justify-between'>
			<div className=''>{getName(agent.name)}</div>
			{agent.useOnline?.profileType === 'vivaSmartCheckout' && <Image src='https://cdn.okeoke.io/brands/global/payments/Viva-Wallet.png' className='mt-1' classNames={{img: 'object-contain'}} height='26px' alt='viva' />}
		</div>
	);
}
